import { faqItems } from '@/mocks/homeMocks';

export default function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 scroll-mt-20 text-center">
            常见问题
          </h2>
          <div className="space-y-3">
            {faqItems.map((item) => (
              <details
                key={item.id}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base text-foreground-950 pr-4">
                    {item.question}
                  </h3>
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 group-open:hidden">
                    <i className="ri-add-line"></i>
                  </span>
                  <span className="shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-primary-500">
                    <i className="ri-subtract-line"></i>
                  </span>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}